import { address } from "/apollo/client/local";
import { AddressState } from "/apollo/client/local/address/address.types";
import i18n from "/i18n";

import { reverseGeocode } from "./freshpaintServices";
import { AWSPlace } from "./geoService.types";

export function formatAddress(p: AWSPlace): AddressState {
  const streetNumber = p.Address?.AddressNumber;
  const streetName = p.Address?.Street;

  return {
    line1: streetNumber && streetName ? `${streetNumber} ${streetName}` : undefined,
    placeId: p.PlaceId,
    city: p.Address?.SubRegion?.Name,
    state: p.Address?.Region?.Code,
    formattedAddress: p.Address?.Label,
    postalCode: p.Address?.PostalCode?.substring(0, 5), //10036-1234 -> 10036
    lat: p.Position[1],
    lng: p.Position[0],
  };
}
type streetComponents = {
  streetNumber: string;
  streetName: string;
};

export function getPartsFromAddress1(line1: string): streetComponents {
  const regex = /^(\d+[A-Z]?)\s(.*)/i;
  const match = line1.match(regex);

  // Return an empty object if there is no match.
  if (!match) {
    return { streetNumber: "", streetName: "" };
  }

  return { streetNumber: match[1], streetName: match[2] };
}

export function updateAddress(newAddress: Partial<AddressState>) {
  address.update(newAddress);
}

export function getAddressCurrentLocation(): Promise<AddressState | undefined> {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        reverseGeocode(
          position.coords.longitude,
          position.coords.latitude,
          (prediction: AWSPlace[] | null) => {
            if (prediction && prediction.length > 0) {
              const address = formatAddress(prediction[0]);
              resolve(address);
            } else {
              resolve(undefined);
            }
          },
        );
      },
      (err) => {
        let friendlyMessage;
        switch (err.code) {
          case err.PERMISSION_DENIED:
            friendlyMessage = i18n.t("geolocation-error.permissionDenied");
            break;
          case err.POSITION_UNAVAILABLE:
            friendlyMessage = i18n.t("geolocation-error.positionUnavailable");
            break;
          case err.TIMEOUT:
            friendlyMessage = i18n.t("geolocation-error.timeout");
            break;
        }

        reject({ err, friendlyMessage });
      },
      {
        timeout: 30000,
      },
    );
  });
}
